import moment from 'moment';
import {
    SET_REFILLS,
    UPDATE_REFILL,
    UPDATE_ACTIVE_TAB,
    SET_DATE_CALLS,
} from '../ActionTypes/ActionTypes';


const initialState = {
    refillsList: [],
    activeTab: 1,
    date: moment().format('YYYY-M-D'),
};

const RefillReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_REFILLS:
        return {
            ...state,
            refillsList: action.payload.data,
        };

    case SET_DATE_CALLS:
        return {
            ...state,
            date: action.payload.data,
        };

    case UPDATE_REFILL:
        state.refillsList.splice(action.payload.id, 1, action.payload.data);
        // console.log(action.payload.id);
        return {
            ...state,
        };

    case UPDATE_ACTIVE_TAB:
        return {
            ...state,
            activeTab: action.payload.data,
        };

    default:
        return state;
    }
};


export default RefillReducer;



// WEBPACK FOOTER //
// ./src/Reducer/RefillManagementReducer.js